$ = require 'jquery'
WindowSize = require 'app/scripts/lib/window-size'

$ ->
  WindowSize.calc()

  resize = null
  $(window).on 'resize', ->
    clearTimeout(resize)
    resize = setTimeout (-> WindowSize.calc()), 200
    return
